import { ThemeProvider } from '@mui/material/styles';
import {
    defaultTheme,
    formatDateNoTimeMonth,
    getAllProductLeadTimes,
} from '../utilities/Utilites';
import * as React from 'react';
import Box from '@mui/system/Box';
import { Card, Grid } from '@mui/material';
import { useGlobalStore } from '../utilities/GlobalState';
import { ProductLeadTimes } from '../interfaces/Interfaces';
import { Datagrid } from '../utilities/Datagrid';
import { DateTime } from 'luxon';

export const LeadsPage = () => {
    const globalState = useGlobalStore((state) => state);
    const [leadTimeData, setLeadTimeData] = React.useState<
        Array<ProductLeadTimes>
    >([]);

    const fetchFiles = (
        token: string,
        roles: string | null,
        updateProductLeadTimes: (allFiles: ProductLeadTimes[]) => void,
    ) =>
        getAllProductLeadTimes(token)
            .then((res) => {
                updateProductLeadTimes(res.data);
                return res.data;
            })
            .then((data) => {
                const cxRoles = roles?.slice(0, -1)?.split(',');
                const filteredData = data.filter((item) =>
                    cxRoles?.includes(item?.category?.toUpperCase() || ''),
                );

                setLeadTimeData(filteredData);
            })
            .catch((e) => console.log(e));

    const idState = globalState.customerId;
    const tokenState = globalState?.authToken;
    const rolesState = globalState?.customerRoles;
    const productLeadTimesState = globalState.setProductLeadTimes;

    React.useEffect(() => {
        fetchFiles(tokenState, rolesState, productLeadTimesState);
    }, [idState, tokenState, rolesState]);

    const getRowId = (row: any) => {
        return row.id;
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Box
                sx={{
                    padding: '30px 10px 10px 10px',
                    maxWidth: '100vp',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Card sx={{ padding: '10px', margin: '10px' }}>
                    <Grid
                        container
                        style={{
                            padding: '10px 10px 10px 20px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            fontWeight: 'bold',
                            fontSize: '20px',
                        }}
                    >
                        <Grid item>
                            <div>Product Lead Time Information</div>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        style={{
                            padding: '10px 10px 10px 20px',
                            // backgroundColor: '#f44336',
                            // color: '#fff',
                            // fontWeight: 'bold',
                            // fontSize: '20px',
                        }}
                    >
                        <Grid item>
                            <div>
                                {'IMPORTANT NOTE: The lead times below are an estimate based on current volumes and an ordered product quantity of "1". ' +
                                    'Lead times could extend when ordering larger quantities or if a backlog exists at time of order. ' +
                                    'All orders are subject to backlog at time of order. ' +
                                    'Rush lead times are possible to achieve but some products or orders may not be eligible.'}
                            </div>
                        </Grid>
                    </Grid>

                    {Datagrid({
                        getRowId: getRowId,
                        pageSize: 20,
                        columns: [
                            {
                                field: 'id',
                                headerName: 'ID',
                                type: 'string',
                                flex: 0.1,
                            },
                            {
                                field: 'product',
                                headerName: 'Product',
                                type: 'string',
                                flex: 1,
                            },
                            {
                                field: 'rush_Lead_Time',
                                headerName: 'Rush Lead',
                                type: 'string',
                                flex: 0.5,
                            },
                            {
                                field: 'standard_Lead_Time',
                                headerName: 'Standard Lead',
                                type: 'string',
                                flex: 0.5,
                            },
                            {
                                field: 'last_Updated',
                                headerName: 'Last Updated',
                                type: 'string',
                                flex: 0.2,
                                renderCell: (params) => {
                                    return (
                                        <>
                                            {formatDateNoTimeMonth(
                                                DateTime.fromISO(
                                                    params?.row?.last_Updated,
                                                ),
                                            )}
                                        </>
                                    );
                                },
                            },
                        ],
                        data: leadTimeData,
                    })}
                </Card>
            </Box>
        </ThemeProvider>
    );
};
